import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  USER_ROLE_ADMIN,
} from 'common/userRoles';

import {
  SR_API_ACTION_ADMIN_DEPLOY,
} from 'api/actionTypes';

import {
  SCREEN_ID_ADMIN_DEPLOYMENTS,
} from 'client/constants/screenIds';

import Navbar from 'client/components/Navbar';
import ButtonDeprecated from 'client/components/ButtonDeprecated';
import H1 from 'client/components/H1';
import SrFormikField from 'client/components/SrFormikField';
import SrLink from 'client/components/SrLink/SrLink';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withApiState from 'client/helpers/withApiState';
import withScreenId from 'client/helpers/withScreenId';
import allowedRoles from 'client/helpers/allowedRoles';
import postWithState from 'client/actions/postWithState';

import log from 'client/lib/log';

const adminDeploymentsFormInitialState = {
  gitBranch: '',
  jobName: 'deploy-dev',
};

const adminDeploymentsFormItems = [
  {
    id: 'gitBranch',
    title: 'Git branch',
    type: 'short_text',
    validations: ['required'],
  },
  {
    id: 'jobName',
    type: 'select',
    properties: {
      placeholder: 'Select deployment environment...',
      choices: [
        {
          label: 'Development',
          value: 'deploy-dev',
        },
        {
          label: 'Development + Refresh DB',
          value: 'deploy-refresh-dev',
        },
        {
          label: 'Staging',
          value: 'deploy-staging',
        },
        {
          label: 'Staging + Refresh DB',
          value: 'deploy-refresh-staging',
        },
        {
          label: 'Production',
          value: 'deploy-prod',
        },
      ],
    },
    validations: ['required'],
  },
];

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withApiState({
  adminDeploymentApiState: {
    action: SR_API_ACTION_ADMIN_DEPLOY,
  },
})
@withScreenId(SCREEN_ID_ADMIN_DEPLOYMENTS)
class AdminDeploymentsPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Admin Deployments | Sunroom Rentals',
    section: 'Admin',
    bodyClasses: 'page-admin',
  });

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      circleCiResponse: null,
    };
  }

  _onDeploymentsFormSubmit = ({ gitBranch, jobName }) => {
    const { dispatch } = this.props;
    this.setState({
      circleCiResponse: null,
    });
    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_DEPLOY,
      payload: {
        gitBranch,
        jobName,
      },
    })
      .then((circleCiResponse) => {
        this.setState({
          circleCiResponse,
        });
      })
      .catch((error) => {
        log.error(error);
      });
  }

  render() {
    const { adminDeploymentApiState } = this.props;
    const { circleCiResponse } = this.state;

    return (
      <div className='adminContainer'>
        <Navbar redirectLogoTo='/admin' />

        <div className='section'>
          <H1>Deployments</H1>

          <Formik
            initialValues={{ ...adminDeploymentsFormInitialState }}
            onSubmit={this._onDeploymentsFormSubmit}
          >
            {(formikBag) => (
              <Form>
                {adminDeploymentsFormItems.map((formField) => (
                  <SrFormikField
                    key={formField.id}
                    formField={formField}
                    formikBag={formikBag}
                  />
                ))}
                <ButtonDeprecated
                  disabled={
                    !formikBag.isValid
                    || adminDeploymentApiState.inProgress
                  }
                  type='submit'
                >
                  {adminDeploymentApiState.inProgress
                    ? 'please wait...'
                    : 'deploy'
                  }
                </ButtonDeprecated>
              </Form>
            )}
          </Formik>
          {circleCiResponse && (
            <div>
              <h1>CircleCi deployment job created</h1><br />
              <SrLink to={circleCiResponse.build_url}>
                {circleCiResponse.build_url}
              </SrLink>
              <br />
              <pre>
                {JSON.stringify(circleCiResponse, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </div>
    );
  }
}

AdminDeploymentsPage.displayName = 'AdminDeploymentsPage';

export default AdminDeploymentsPage;
